export default __webpack_public_path__ + "static/media/lock.586101dc.svg";